import reframe from 'nike-re-framejs';

reframe.regSub('charity.value', db => db.getIn(['charity', 'value'], 0));
